const API_VERSION = `/api/${process.env.REACT_APP_API_VERSION}`;

export const ApiPaths = {
  curriculums: `${API_VERSION}/curriculums`,
  subject_levels: `${API_VERSION}/subject_levels`,
  topics: `${API_VERSION}/topics`,
  tags: `${API_VERSION}/tags`,
  subTopic: `${API_VERSION}/sub_topics`,
  questions: `${API_VERSION}/questions`,
  diagnostic: `${API_VERSION}/diagnostic`,
  stripe: `${API_VERSION}/stripe`,
  usage: `${API_VERSION}/usage`,
  meta_tag: `${API_VERSION}/meta_tags`,
};

export const AdminApiPaths = {
  sub_topics: `${API_VERSION}/admin/sub_topics`,
  questions: `${API_VERSION}/admin/questions`,
  quizzes: `${API_VERSION}/admin/quizzes`,
  students: `${API_VERSION}/admin/students`,
  users: `${API_VERSION}/admin/users`,
  submissions: `${API_VERSION}/admin/submissions`,
  resources: `${API_VERSION}/admin/resources`,
  subject_levels: `${API_VERSION}/admin/subject_levels`,
  topics: `${API_VERSION}/admin/topics`,
  gptQuestion: `${API_VERSION}/admin/gptQuestion`,
  structuredEssayQuestions: `${API_VERSION}/admin/structuredEssayQuestions`,
};

export const UserApiPaths = {
  quizzes: `${API_VERSION}/user/quizzes`,
  submissions: `${API_VERSION}/user/submissions`,
  trial: `${API_VERSION}/user/trial`,
  trialRecordings: `${API_VERSION}/trial-recordings`,
  bookmark: `${API_VERSION}/bookmark`,
  report: `${API_VERSION}/platform/report`,
  session: `${API_VERSION}/user/session`,
  progress: `${API_VERSION}/user/progress`,
  analytics: `${API_VERSION}/platform/analytics`,
  questions: `${API_VERSION}/user/questions`,
};
